var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaptureicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.155 18.234H5.845a.883.883 0 0 1-.88-.886V8.48c0-.49.394-.887.88-.887h2.198l.44-.887s.393-.886.88-.886h5.275c.486 0 .88.886.88.886l.439.887h2.198c.486 0 .88.397.88.887v8.867a.884.884 0 0 1-.88.886zM12 16.461c-1.942 0-3.517-1.588-3.517-3.547 0-1.958 1.575-3.547 3.517-3.547s3.517 1.589 3.517 3.547c0 1.959-1.575 3.547-3.517 3.547zm0-6.207c-1.457 0-2.638 1.191-2.638 2.66 0 1.47 1.181 2.66 2.638 2.66 1.457 0 2.638-1.19 2.638-2.66 0-1.47-1.181-2.66-2.638-2.66z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureicon);
export default __webpack_public_path__ + "static/media/captureicon.ad7809d7a936010801fbfdce79475421.svg";
export { ForwardRef as ReactComponent };